/* lua.js generated code undefined */

let Base = unpack(require("clover/logic/userTagData/UserTagBase"))[0]
let TagConfig = require("clover/config/userTag/FourWeeksPaymentTagConfig")
let Tag = xClass("FourWeeksPaymentTag", Base)
Tag.prototype.init = function () {
    let self = this
    self.record = table()
    UserDeal.getInstance().on(UserDealEvent.BuyGoods, handler(self, self.logBuyGoods))
}
Tag.prototype.logBuyGoods = function (event) {
    let self = this
    if (event.payType === UserDealPayType.kCoin || event.payType === UserDealPayType.kCash) {
        return 
    }
    table.insert(self.record, table(
        [1, "price", event.price],
        [1, "time", Localhost.time()],
        [1, "goodsId", event.goodsId],
        [1, "num", event.num],
        [1, "type", event.payType],
        [1, "totalPrice", event.totalPrice]
    ))
}
Tag.prototype.convertOnlineRecord = function (data) {
    let self = this
    let ret = table()
    for (let i = 1, v = data.cashLogs[1]; v; i++, v = data.cashLogs[i]) {
        table.insert(ret, table(
            [1, "price", v.price],
            [1, "time", tonumber(v.time) || 0],
            [1, "goodsId", v.goodsId],
            [1, "num", v.num || 1],
            [1, "type", v.type],
            [1, "totalPrice", (v.num || 1) * v.price]
        ))
    }
    // dump(data.cashLogs,"data.cashLogs")
    // dump(ret,"ret")
    // debug.debug()
    return table([1, "record", ret])
}
Tag.prototype.refresh = function (data) {
    let self = this
    if (data.record) {
        self.record = table()
        for (let k in data.record) {
            let v = data.record[k]
            if ($null(v)) continue
            table.insert(self.record, clone(v))
        }
    }
    // dump(data.record,"data.record")
    // dump(self.record,"self.record")
    // debug.debug()
}
Tag.prototype.getTag = function () {
    let self = this
    let dayStart = Localhost.getTodayStart()
    let dayInSec = 86400
    let [first, last] = [(dayStart - dayInSec * 28) * 1000, (dayStart + dayInSec) * 1000]
    let payment = 0
    table.each(self.record, function (v) {
        if (v.time >= first && v.time < last) {
            if (v.totalPrice === null) {
                v.totalPrice = (v.num || 1) * (v.price || 0)
            }
            payment = payment + v.totalPrice
        }
    })
    for (let k in TagConfig) {
        let v = TagConfig[k]
        if ($null(v)) continue
        if (payment >= v.min && payment <= v.max) {
            return k
        }
    }
    return 0
}
Tag.prototype.encode = function () {
    let self = this
    let data = table()
    data.record = self.record
    return data
}
module.exports = Tag
